import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import { removeUserFromCashier } from "../../../../../services/Users";

const UnlinkCashierDialog = ({ userId, userName, cashier, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  if (!cashier) return null;

  const { id: cashierId, name: cashierName } = cashier;

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);
    setSuccessMessage("");
    try {
      await removeUserFromCashier({ user_id: userId, cashier_id: cashierId });
      setSuccessMessage(`✅ تم إلغاء الربط بين "${cashierName}" و "${userName}" بنجاح`);
      setTimeout(() => {
        if (onSuccess) onSuccess();
        onClose();
      }, 1500);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>❌ إلغاء ربط الكاشير</DialogTitle>
      <DialogContent>
        <Typography mb={2}>
          هل أنت متأكد من إلغاء ربط الكاشير <strong>{cashierName}</strong> للمستخدم <strong>{userName}</strong>؟
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        {successMessage && <Alert severity="success">{successMessage}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>إلغاء</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : "تأكيد الإلغاء"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnlinkCashierDialog;